<app-header></app-header>
<app-landing></app-landing>
<app-about-us></app-about-us>
<app-gcg></app-gcg>
<app-management></app-management>
<app-technology></app-technology>
<app-financial-report></app-financial-report>
<app-footer></app-footer>
